<template>
  <v-container fluid>
    <PageTitle>

      <v-icon left>
        fal fa-fw fa-books
      </v-icon>

      <div class="mr-2">
        My Content Library
      </div>

      <v-btn icon
             rounded
             title="Refresh"
             :disabled="presentationsLoading"
             @click.prevent="fetchData">
        <v-icon v-if="presentationsLoading">
          fas fa-fw fa-spin fa-spinner
        </v-icon>
        <v-icon v-else>
          fas fa-fw fa-sync
        </v-icon>
      </v-btn>
    </PageTitle>

    <ContentLibrary>
    </ContentLibrary>

  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import ContentLibrary from './components/ContentLibrary';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle, ContentLibrary},
  metaInfo() {
    return {
      title: 'My Content Library',
    }
  },
  data() {
    return {
      form: new Form({
        can_be_shared: '',
        can_be_forwarded: '',
        can_be_shared_link: '',
        can_be_annotated: '',
        can_be_downloaded: '',
        external_id: '',
        locale: '',
        group: '',
        sortBy: ['name'],
        sortDesc: [false],
        owner_id: '',
        page: 1,
        per_page: 10,
        status: 'Active',
        expires_at: {
          range: '',
          start: '',
          end: '',
        },
        created_at: {
          range: '',
          start: '',
          end: '',
        },
        updated_at: {
          range: '',
          start: '',
          end: '',
        },
        type: '',
      }),
      meta: null,
      selected: [],
    }
  },
  computed: {
    ...mapGetters([
      'groups',
      'isAdmin',
      'isMember',
      'team',
      'user',
    ]),
    ...mapGetters('content', [
      'presentationsLoading',
    ])
  },
  methods: {
    fetchData() {
      this.$store.dispatch('content/fetchUserData') // MLD-3342
      /*this.$store.dispatch('content/fetchBookmarks').then().catch(() => {}) // MLD-2107
      this.$store.dispatch('content/fetchFolders').then().catch(() => {})
      this.$store.dispatch('content/fetchProducts').then().catch(() => {}); // MLD-3306
      this.$store.dispatch('content/fetchPresentations').then().catch(() => {})*/
    }
  }
}
</script>
